import { EventEmitter, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import * as en from '../../../assets/i18n/en.json';
import { Observable } from 'rxjs';

interface Translations {
    [key: string]: string;
}

@Injectable({ providedIn: 'root' })
export class TranslationService {
    readonly onLangChange = new EventEmitter<any>();

    constructor(private readonly translate: TranslateService) {
        this.translate.onLangChange.subscribe(event => {
            this.onLangChange.emit(event);
        });
    }

    public translateMsgObservable(msg: string): Observable<string> {
        return this.translate.get(msg);
    }

    public translateMsg(msg: string, args?: any): string {
        return this.translate.instant(msg, args);
    }

    public translateFromValue(value: any, args?: any): any {
        let modifiedValue = value;
        let result;
        const keysGeneral = Object.keys(en.general);
        const keysMessages = Object.keys(en.messages);

        result = keysGeneral.find(
            key => (en.general as Translations)[key].toLowerCase() === (value ?? '').toString().toLowerCase()
        );

        if (result !== undefined) {
            modifiedValue = 'general.' + result;
        } else {
            result = keysMessages.find(
                key =>
                    (en.messages as any as Translations)[key].toLowerCase() === (value ?? '').toString().toLowerCase()
            );
            if (result !== undefined) {
                modifiedValue = 'messages.' + result;
            }
        }

        return this.translate.instant(modifiedValue);
    }
}
